import { useState, useEffect } from "react";
import { decorateRichText } from "./utils";

//HACK: add attributes target="_blank" and rel="noopener noreferrer" to every <a /> tag
export const useFixHTML = html => {
    const [value, setValue] = useState(html);

    useEffect(() => {
        setValue(decorateRichText(html));
    }, [html]);

    return value;
};
